import { getEnvVar } from "./environment";

export const openChat = () => {
  window.open(getEnvVar("CHAT"), "_blank", "height=600,width=500");
};
